export const environment = {
  production: true,
  apiBaseUrl: 'https://api.lemonmode.com/v1',
  imageUrl: 'https://api.lemonmode.com/',
  SECRET_KEY: 'uTv@!ScTaS3#bE&o$',
  domain_name: 'api.lemonmode.com',
  siteURL: 'https://lemonmode.com/'
};
